module.exports = __webpack_public_path__ + "static/media/Desktop_Purpose_39.63016f9b.png";